module.exports = __webpack_public_path__ + "static/media/dashboard-purple.3004607a.svg";